import React from 'react'

const SidebarSettingsIcon = ({ isActive }) => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.8074 6.48421L18.185 5.40412C17.6584 4.4902 16.4914 4.17492 15.5763 4.69931V4.69931C15.1406 4.95594 14.6208 5.02875 14.1314 4.90168C13.6421 4.77462 13.2233 4.45811 12.9676 4.02197C12.803 3.74474 12.7146 3.42899 12.7113 3.10664V3.10664C12.7261 2.58982 12.5311 2.089 12.1708 1.71827C11.8104 1.34753 11.3153 1.13846 10.7982 1.13867H9.54423C9.0377 1.13867 8.55205 1.34051 8.19473 1.69954C7.83742 2.05857 7.63791 2.54519 7.64034 3.05172V3.05172C7.62533 4.09752 6.77321 4.93741 5.7273 4.9373C5.40494 4.93395 5.08919 4.84554 4.81197 4.68101V4.68101C3.89679 4.15661 2.72985 4.47189 2.20327 5.38581L1.53508 6.48421C1.00914 7.39699 1.32013 8.5632 2.23073 9.09291V9.09291C2.82263 9.43464 3.18726 10.0662 3.18726 10.7497C3.18726 11.4331 2.82263 12.0647 2.23073 12.4064V12.4064C1.32129 12.9325 1.00996 14.0959 1.53508 15.0059V15.0059L2.16666 16.0952C2.41338 16.5404 2.82734 16.8689 3.31693 17.008C3.80652 17.1472 4.33137 17.0855 4.77535 16.8366V16.8366C5.21181 16.5819 5.73192 16.5122 6.22007 16.6428C6.70822 16.7734 7.12397 17.0936 7.3749 17.5323C7.53943 17.8095 7.62784 18.1252 7.63119 18.4476V18.4476C7.63119 19.5041 8.48769 20.3606 9.54423 20.3606H10.7982C11.8512 20.3607 12.7062 19.5097 12.7113 18.4568V18.4568C12.7088 17.9486 12.9096 17.4606 13.2689 17.1013C13.6282 16.742 14.1162 16.5413 14.6243 16.5437C14.9459 16.5523 15.2604 16.6404 15.5397 16.8V16.8C16.4524 17.3259 17.6186 17.0149 18.1484 16.1043V16.1043L18.8074 15.0059C19.0625 14.5681 19.1325 14.0466 19.0019 13.557C18.8714 13.0673 18.551 12.65 18.1117 12.3973V12.3973C17.6725 12.1446 17.3521 11.7272 17.2215 11.2375C17.091 10.7479 17.161 10.2264 17.4161 9.78856C17.582 9.49893 17.8221 9.25879 18.1117 9.09291V9.09291C19.0169 8.56349 19.3271 7.40409 18.8074 6.49336V6.49336V6.48421Z"
      stroke={isActive ? '#FFFFFF' : '#2D264B'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="10.1752"
      cy="10.7494"
      r="2.63616"
      stroke={isActive ? '#FFFFFF' : '#2D264B'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SidebarSettingsIcon
